import { EntitySelectorsFactory } from '@ngrx/data';

import { TipoEquipamientoProcesamiento } from './tipos-equipamiento-procesamiento.model';

export const tipoEquipamientoProcesamientoSelectors =
  new EntitySelectorsFactory().create<TipoEquipamientoProcesamiento>('TipoEquipamientoProcesamiento');

export const selectAllTiposEquipamientoProcesamiento =
  tipoEquipamientoProcesamientoSelectors.selectEntities;

